import { render } from "./AddNetworkOffering.vue?vue&type=template&id=31853cb4&scoped=true"
import script from "./AddNetworkOffering.vue?vue&type=script&lang=js"
export * from "./AddNetworkOffering.vue?vue&type=script&lang=js"

import "./AddNetworkOffering.vue?vue&type=style&index=0&id=31853cb4&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31853cb4"]])

export default __exports__